import { VERTICAL_SCROLL_STYLE } from 'themes/defaultMuiTheme';
import { makeStyles } from 'tss-react/mui';
import {
  BORDER_BUTTON_GREY_2,
  BUTTON_GREY,
  DATA_MANAGEMENT_BLUE,
  DATA_MANAGEMENT_BLUE_2,
  HISTOWIZ_PRIMARY_COLOR,
  LIGHT_GREY,
  PRIMARY_BACKGROUND,
  SECONDARY_BLUE_2,
  TEXT_BUTTON_GREY,
  TRANSPARENT_BLACK_10,
  TRANSPARENT_BLACK_26,
  WHITE,
  WHITE_SMOKE,
  WHITE_SMOKE_3,
} from 'utilities/colors';

export const useBlocksPageV2Styles = makeStyles()((theme) => ({
  teamMenuItem: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    backgroundColor: 'inherit',
    color: 'inherit',
    paddingLeft: '2.5rem',
    maxWidth: '20rem',
  },
  teamMenuItemSelected: {
    backgroundColor: `${theme.palette.primary.main} !important`,
    color: WHITE,
    paddingLeft: '0.5rem',
  },
  teamSelectedIcon: {
    color: WHITE,
    minWidth: '1.5rem !important',
    marginRight: '0.5rem',
  },
  teamMenuItemText: {
    display: 'flex',
    justifyContent: 'space-between',
    maxWidth: '17rem',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  viewSlidesButton: {
    paddingInline: '0.5rem',
  },
  clickable: {
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  newRowClass: {
    backgroundColor: 'lightblue',
  },
  container: {
    flexWrap: 'nowrap',
  },
  table: {
    width: '100%',
    height: 'calc(100vh - 13rem)',
    background: 'transparent',
    display: 'grid',
    gridTemplateRows: 'min-content min-content auto',
  },
  tableWrapper: {
    marginTop: '1.5rem',
    padding: '0 !important',
    backgroundColor: 'white',
    borderRadius: '4px',
  },
  imagesWrapper: {
    marginLeft: '1rem',
    marginTop: '1.5rem',
    backgroundColor: 'white',
    maxHeight: 'calc(100vh - 13rem)',
    height: 'calc(100vh - 13rem)',
    display: 'grid',
  },
  header: {
    display: 'flex',
    gap: 20,
    alignItems: 'center',
    marginLeft: 'auto',
  },
  title: {
    textTransform: 'uppercase',
    fontSize: '1rem',
    padding: '1.12rem 0',
    fontWeight: 500,
    letterSpacing: '0.1rem',
    display: 'flex',
  },
  titleSkeleton: {
    fontSize: '1rem',
    marginLeft: '0.25rem',
  },
  separator: {
    background: TRANSPARENT_BLACK_26,
    width: '1px',
    height: '3.8rem',
  },
  imageSectionHeader: {
    display: 'flex',
    gap: 10,
    alignItems: 'center',
  },
  subHeader: {
    letterSpacing: 0,
    padding: '0.25rem 0 0 0.5rem',
  },
  slideCard: {
    textAlign: 'center',
  },
  images: {
    display: 'flex',
  },
  searchInput: {
    padding: '0 1rem',
    width: '30rem',
    fontSize: '1rem',
    [theme.breakpoints.down('lg')]: {
      width: '22rem',
    },
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  processButton: {
    marginLeft: '1rem',
    padding: '0.25rem 1rem',
    fontSize: '0.75rem',
    lineHeight: '0.875rem',
    fontWeight: 500,
    marginTop: '0.16rem',
    textTransform: 'uppercase',
  },
  associatedText: {
    fontSize: '0.75rem',
    lineHeight: '0.875rem',
    fontWeight: 500,
    marginTop: '0.16rem',
    textTransform: 'uppercase',
  },
  processCounter: {
    fontSize: '0.85rem',
    margin: '0 0.5rem',
    width: '2rem',
    height: '1.4rem',
    color: WHITE,
    fontWeight: 500,
    borderRadius: '4px',
    textAlign: 'center',
    backgroundColor: SECONDARY_BLUE_2,
  },
  blocksCount: {
    margin: '1rem',
    padding: '0.25rem',
    width: '15rem',
  },
  blocksCountWrapper: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #ccc',
    width: '35rem',
    height: '3.25rem',
    margin: '0.5rem 0.5rem 0 0',
    borderRadius: '4px',
    backgroundColor: theme.palette.background.main,
  },
  barcodeContainer: {
    overflow: 'hidden',
    aspectRatio: '1 / 1',
    cursor: 'pointer',
  },
  switch: {
    padding: '0.2rem 1rem',
    whiteSpace: 'nowrap',
  },
  counter: {
    width: '3rem',
    height: '1.5rem',
    border: '1px transparent',
    borderRadius: '4px',
    backgroundColor: '#838a8e',
    textAlign: 'center',
    marginLeft: '1rem',
    color: WHITE_SMOKE,
  },
  barcodeText: {
    fontSize: '0.75rem',
    fontWeight: 'bold',
    width: '100%',
    textAlign: 'left',
    wordBreak: 'break-word',
  },
  slideSectionText: {
    [theme.breakpoints.down('lg')]: {
      fontSize: '0.75rem',
    },
    fontWeight: 'bold',
  },
  pageHeader: {
    background: WHITE,
    borderRadius: '5px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 40,
    padding: '0 1.75rem',
    fontWeight: 'bold',
    fontSize: '1.3rem',
    letterSpacing: '0.1rem',
    width: '100%',
  },
  teamSelect: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    textTransform: 'uppercase',
  },
  tableHeader: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 12,
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '1.2rem 2rem',
    borderBottom: `1px solid ${TRANSPARENT_BLACK_26}`,
  },
  tableHeaderContainer: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 12,
  },

  addSamplesBtn: {
    width: 'fit-content',
    whiteSpace: 'nowrap',
    margin: 0,
  },
  exportButton: {
    marginLeft: 'auto',
  },
  tableTitle: {
    fontSize: '1rem',
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: '0.1rem',
    color: 'black',
  },
  tableTitleContainer: {
    maxWidth: '22rem',
  },
  tableTitleWrapper: {},
  tab: {
    display: 'flex',
    width: '50%',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: '1.75rem',
    paddingBottom: '1.75rem',
    gap: '0.5rem',
    cursor: 'pointer',
    fontSize: '0.875rem',
    boxSizing: 'border-box',
    position: 'relative',
    [theme.breakpoints.down('laptop')]: {
      paddingTop: '1rem',
      paddingBottom: '1rem',
    },
  },
  tabsSlider: {
    position: 'absolute',
    bottom: 0,
    height: '100%',
    backgroundColor: PRIMARY_BACKGROUND,
    borderBottom: `4px solid ${HISTOWIZ_PRIMARY_COLOR}`,
    transition: 'left 0.3s ease-in-out, width 0.3s ease-in-out',
  },
  activeTab: {
    color: HISTOWIZ_PRIMARY_COLOR,
  },
  disabledTab: {
    cursor: 'not-allowed',
  },
  tabs: {
    background: WHITE,
    display: 'flex',
    borderBottom: `1px solid ${TRANSPARENT_BLACK_10}`,
    position: 'relative',
  },
  label: {
    [theme.breakpoints.down('lg')]: {
      fontSize: '0.7rem',
    },
  },
  tabCounter: {
    padding: '0.2rem 0.6rem',
    fontSize: '0.75rem',
    fontWeight: 400,
    borderRadius: 5,
    color: WHITE,
    background: HISTOWIZ_PRIMARY_COLOR,
  },
  slideName: {
    fontSize: '0.625rem',
    textAlign: 'left',
    wordBreak: 'break-word',
  },
  orderName: {
    fontSize: '0.625rem',
    opacity: 0.6,
  },
  noData: {
    padding: '1rem',
    margin: '0 auto',
    textAlign: 'center',
  },
  formWrapper: {
    ...VERTICAL_SCROLL_STYLE,
    overflowY: 'auto',
    height: '70vh',
    width: '75rem',
    maxWidth: '80vw',
  },
  continueButton: {
    position: 'absolute',
    backgroundColor: DATA_MANAGEMENT_BLUE,
    border: `${DATA_MANAGEMENT_BLUE} 1px solid`,
    borderLeft: 'none',
    borderRadius: '0 4px 4px 0',
    right: 0,
    top: 0,
    fontSize: '0.75rem',
    letterSpacing: '0.05em',
    height: '100%',
    width: '5rem',
    boxShadow: 'none',
    ':disabled': {
      backgroundColor: DATA_MANAGEMENT_BLUE_2,
      color: WHITE,
    },
    '&:hover': {
      backgroundColor: DATA_MANAGEMENT_BLUE_2,
      color: DATA_MANAGEMENT_BLUE,
      boxShadow: 'none',
    },
  },
  changelog: {
    border: `2px solid ${BORDER_BUTTON_GREY_2}`,
    color: BUTTON_GREY,
    borderRadius: '4px',
    height: '2.5rem',
    padding: '0.25rem',
  },
  changeIcon: {
    height: '100%',
    marginRight: '0.25rem',
    color: TEXT_BUTTON_GREY,
  },
  imagesHeader: {
    backgroundColor: WHITE_SMOKE_3,
    padding: '1.375rem 1.8rem',
    borderBottom: '1px solid',
    borderTop: '1px solid',
    borderColor: TRANSPARENT_BLACK_26,
    fontSize: '1.125rem',
    fontWeight: 500,
    [theme.breakpoints.down('lg')]: {
      padding: '1rem 1.8rem',
    },
  },
  imagesTools: {
    padding: '0.75rem 1.875rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down('laptop')]: {
      flexDirection: 'column',
      gap: 12,
    },
  },
  imagesNavigation: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  imagesArrow: {
    width: '1.5rem',
    height: '1.5rem',
    border: '1px solid #D9D9D9',
    borderRadius: '0.25rem',
    color: '#1C1B1F',
    cursor: 'pointer',

    '&.disabled': {
      color: '#D9D9D9',
      cursor: 'not-allowed',
    },
  },
  imagesCurrentPage: {
    width: '1.75rem',
    height: '1.75rem',
    border: '1px solid black',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '0.125rem',
    marginLeft: '0.75rem',
    marginRight: '0.275rem',
    backgroundColor: WHITE_SMOKE_3,
  },
  imagesTotalPages: {
    opacity: 0.7,
    marginLeft: '0.43rem',
    marginRight: '0.75rem',
  },
  scrollableContainer: {
    overflowY: 'auto',
    ...VERTICAL_SCROLL_STYLE,
  },
  imagesTab: {
    overflowY: 'hidden',
  },
  tabContainer: {
    height: '100%',
    display: 'grid',
    gridTemplateRows: 'min-content min-content auto',
  },
  menu: {
    marginTop: '0.25rem',
  },
  menuItem: {
    color: TEXT_BUTTON_GREY,
    textTransform: 'uppercase',
    fontSize: '0.75rem',
    fontWeight: 500,
  },
}));

export const blocksSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    display: 'flex',
    alignItems: 'center',
    borderColor: DATA_MANAGEMENT_BLUE,
    paddingLeft: '1.5rem',
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    lineHeight: '0.75rem',
    fontSize: '0.75rem',
    minHeight: '2rem',
    height: '2rem',
    cursor: state.isDisabled ? 'not-allowed !important' : 'pointer',
    '&:hover': {
      borderColor: DATA_MANAGEMENT_BLUE,
    },
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    order: 2,
    position: 'absolute',
    right: '12.5rem',
    color: DATA_MANAGEMENT_BLUE,
    paddingTop: 0,
    marginTop: '-1px',
    paddingBottom: 0,
    '&:hover': {
      color: DATA_MANAGEMENT_BLUE_2,
    },

    '&>svg': {
      width: '1.25rem',
      height: '1.25rem',
    },
  }),
  clearIndicator: (provided) => ({
    ...provided,
    order: 1,
    position: 'absolute',
    right: '5rem',
    color: DATA_MANAGEMENT_BLUE,
    '&:hover': {
      color: DATA_MANAGEMENT_BLUE_2,
    },

    '&>svg': {
      width: '1rem',
      height: '1rem',
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    paddingTop: 0,
    paddingBottom: 0,
    height: '100%',
  }),
  placeholder: (provided) => ({
    ...provided,
    lineHeight: '0.75rem',
    color: DATA_MANAGEMENT_BLUE,
    fontSize: '0.75rem',
  }),
  singleValue: (provided) => ({
    ...provided,
    display: 'flex',
    alignItems: 'center',
    lineHeight: '0.75rem',
    color: DATA_MANAGEMENT_BLUE,
    fontSize: '0.75rem',
  }),
};

export const useBlockToProcessStyles = makeStyles()({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: WHITE_SMOKE,
    height: '78vh',
  },
  tableContainer: {
    width: '100%',
    height: '65vh',
    margin: '1rem 1rem 0 1rem',
    borderBottom: `2px solid ${LIGHT_GREY}`,
  },
  tableHeadCell: {
    fontWeight: 'bold',
  },
  actionButton: {
    margin: '0.5rem',
  },
  selectWrapper: {
    display: 'flex',
    flexDirection: 'row',
  },
  actionSelect: {
    margin: '1rem',
    width: '10rem',
    height: '2rem',
  },
});
